import { connect } from 'react-redux'
import { lifecycle, compose } from 'recompose'
import withType from 'components/common/hoc/withType'
import {
  setVehicleData,
  resetModal,
  handlePositionChange,
  changeVehicleUpdateHandler,
  updateGarage
} from '../actions'
import { getCurrentTab } from '../selectors'
import VehicleMainContent from './VehicleMainContent'

const withModalLifecycle = lifecycle({
  componentDidMount() {
    const { UserVehicleDetails } = this.props

    this.props.setVehicleData(UserVehicleDetails)

    // We can't have an action in an initial state
    this.props.changeVehicleUpdateHandler(updateGarage)
  },

  componentDidUpdate({ UserVehicleDetails }) {
    if (UserVehicleDetails !== this.props.UserVehicleDetails) {
      this.props.setVehicleData(this.props.UserVehicleDetails)
    }
  },

  componentWillUnmount() {
    this.props.resetModal()
  }
})

const mapStateToProps = state => ({
  currentTab: getCurrentTab(state)
})

const mapDispatchToProps = {
  setVehicleData,
  resetModal,
  handlePositionChange,
  changeVehicleUpdateHandler
}

export default compose(
  withType({ type: 'VehicleMainContent' }),
  connect(mapStateToProps, mapDispatchToProps),
  withModalLifecycle
)(VehicleMainContent)
